(() => {
  const root = document.querySelector('.p10357645771073-page[data-v3-page]');
  if (!root) return;

  const activeTheme = window.Shopify && window.Shopify.theme;
  const previewUrl = new URL(window.location.href);
  const previewThemeIds = previewUrl.searchParams.getAll('preview_theme_id');
  const viewSuffixes = previewUrl.searchParams.getAll('view');
  const activeThemeId = String((activeTheme && activeTheme.id) || '');
  const activeThemeRole = String((activeTheme && activeTheme.role) || '').toLowerCase();
  if (
    previewThemeIds.length === 0
    && viewSuffixes.length === 1
    && viewSuffixes[0] === 'p10357645771073'
    && activeThemeRole === 'unpublished'
    && /^[1-9][0-9]*$/.test(activeThemeId)
  ) {
    previewUrl.searchParams.set('preview_theme_id', activeThemeId);
    window.history.replaceState(window.history.state, '', previewUrl.toString());
  }

  const variantSelects = Array.from(root.querySelectorAll('[data-v3-variant-select]'));
  const variantChoices = Array.from(root.querySelectorAll('[data-variant-choice]'));
  const applyQuantityRule = (box, option) => {
    if (!box || !option) return;
    const min = option.dataset.v3QuantityMin || '1';
    const max = option.dataset.v3QuantityMax || '';
    const step = option.dataset.v3QuantityStep || '1';
    box.querySelectorAll('[data-v3-quantity-input]').forEach((input) => {
      input.setAttribute('min', min);
      input.setAttribute('step', step);
      if (max) input.setAttribute('max', max);
      else input.removeAttribute('max');
    });
  };
  const syncVariant = (source) => {
    const id = String(source.value || source.dataset.variantId || '');
    if (!id) return;

    variantSelects.forEach((select) => {
      if (select.value !== id) select.value = id;
    });

    variantChoices.forEach((choice) => {
      const selected = String(choice.dataset.variantId) === id;
      choice.classList.toggle('is-selected', selected);
      choice.setAttribute('aria-checked', selected ? 'true' : 'false');
      choice.dataset.selected = selected ? 'true' : 'false';
      choice.tabIndex = selected ? 0 : -1;
    });

    root.querySelectorAll('[data-v3-purchase]').forEach((box) => {
      const select = box.querySelector('[data-v3-variant-select]');
      const option = select.options[select.selectedIndex];
      const localChoice = Array.from(box.querySelectorAll('[data-variant-choice]'))
        .find((choice) => String(choice.dataset.variantId) === id);
      const title = (localChoice && localChoice.dataset.variantTitle)
        || (option && option.dataset.v3OptionTitle)
        || '';
      const optionPrice = (localChoice && localChoice.dataset.v3OptionPrice)
        || (option && option.dataset.v3OptionPrice)
        || '';
      const selectedLabel = box.querySelector('[data-selected-variant]');
      const price = box.querySelector('[data-v3-current-price]');
      const addButton = box.querySelector('[data-add-button]');

      box.dataset.selectedVariantId = id;
      applyQuantityRule(box, option);
      if (selectedLabel) selectedLabel.textContent = title;
      if (price && optionPrice) price.textContent = optionPrice;
      if (addButton && option) addButton.disabled = option.disabled;
    });

    const firstQuantityInput = root.querySelector('[data-v3-quantity-input]');
    if (firstQuantityInput) syncQuantity(firstQuantityInput, { force: true });

    const variantUrl = new URL(window.location.href);
    variantUrl.searchParams.set('variant', id);
    window.history.replaceState(window.history.state, '', variantUrl.toString());
  };

  variantSelects.forEach((select) => {
    select.addEventListener('change', () => syncVariant(select));
  });

  variantChoices.forEach((choice) => {
    choice.addEventListener('click', () => syncVariant(choice));
    choice.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
      const group = choice.closest('[role="radiogroup"]');
      const choices = group
        ? Array.from(group.querySelectorAll('[data-variant-choice]:not(:disabled)'))
        : [];
      if (!choices.length) return;
      event.preventDefault();
      const currentIndex = Math.max(0, choices.indexOf(choice));
      let nextIndex = currentIndex;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = choices.length - 1;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + choices.length) % choices.length;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % choices.length;
      choices[nextIndex].focus();
      choices[nextIndex].click();
    });
  });
  const quantityInputs = Array.from(root.querySelectorAll('[data-v3-quantity-input]'));
  const quantityAttribute = (input, name, fallback) => {
    const raw = input.getAttribute(name);
    if (raw === null || raw === '' || (name === 'step' && raw === 'any')) return fallback;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : fallback;
  };
  const quantityPrecision = (...values) => Math.min(6, values.reduce((maximum, value) => {
    const raw = String(value);
    const decimal = raw.includes('.') ? raw.length - raw.indexOf('.') - 1 : 0;
    return Math.max(maximum, decimal);
  }, 0));
  const normalizeQuantity = (input, rawValue) => {
    const minimum = quantityAttribute(input, 'min', 1);
    const rawMaximum = quantityAttribute(input, 'max', Number.POSITIVE_INFINITY);
    const maximum = rawMaximum >= minimum ? rawMaximum : Number.POSITIVE_INFINITY;
    const rawStep = quantityAttribute(input, 'step', 1);
    const step = rawStep > 0 ? rawStep : 1;
    const numeric = Number.isFinite(rawValue) ? rawValue : minimum;
    const bounded = Math.min(maximum, Math.max(minimum, numeric));
    const stepped = minimum + Math.round((bounded - minimum) / step) * step;
    const clamped = Math.min(maximum, Math.max(minimum, stepped));
    return Number(clamped.toFixed(quantityPrecision(minimum, step, maximum)));
  };
  const updateQuantityControls = (input) => {
    const stepper = input.closest('[data-v3-quantity-stepper]');
    if (!stepper) return;
    const value = normalizeQuantity(input, Number(input.value));
    const minimum = quantityAttribute(input, 'min', 1);
    const maximum = quantityAttribute(input, 'max', Number.POSITIVE_INFINITY);
    const decrement = stepper.querySelector('[data-v3-quantity-decrement]');
    const increment = stepper.querySelector('[data-v3-quantity-increment]');
    if (decrement) decrement.disabled = value <= minimum;
    if (increment) increment.disabled = Number.isFinite(maximum) && value >= maximum;
  };
  const syncQuantity = (source, { force = false } = {}) => {
    const empty = source.value.trim() === '';
    const rawValue = Number(source.value);
    if ((empty || !Number.isFinite(rawValue)) && !force) {
      updateQuantityControls(source);
      return null;
    }
    const value = normalizeQuantity(source, rawValue);
    quantityInputs.forEach((input) => {
      input.value = String(normalizeQuantity(input, value));
      updateQuantityControls(input);
    });
    return value;
  };
  quantityInputs.forEach((input) => {
    input.addEventListener('input', () => syncQuantity(input));
    input.addEventListener('change', () => syncQuantity(input, { force: true }));
    input.addEventListener('blur', () => syncQuantity(input, { force: true }));
  });
  root.querySelectorAll('[data-v3-quantity-decrement], [data-v3-quantity-increment]').forEach((control) => {
    control.addEventListener('click', () => {
      const stepper = control.closest('[data-v3-quantity-stepper]');
      const input = stepper && stepper.querySelector('[data-v3-quantity-input]');
      if (!input) return;
      syncQuantity(input, { force: true });
      if (control.hasAttribute('data-v3-quantity-decrement')) input.stepDown();
      else input.stepUp();
      syncQuantity(input, { force: true });
      input.focus();
    });
  });
  if (variantSelects[0]) syncVariant(variantSelects[0]);
  if (quantityInputs[0]) syncQuantity(quantityInputs[0], { force: true });

  const productForms = Array.from(root.querySelectorAll('.p10357645771073-product-form'));
  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartAddUrl = `${shopRoot.replace(/\/?$/, '/')}cart/add.js`;
  const addFromForm = async (form) => {
    const button = form.querySelector('[data-add-button]');
    const status = form.querySelector('[data-v3-cart-status]');
    const variant = form.querySelector('[data-v3-variant-select]');
    const quantityInput = form.querySelector('[data-v3-quantity-input]');
    const normalizedQuantity = quantityInput ? syncQuantity(quantityInput, { force: true }) : 1;
    const quantity = Number(normalizedQuantity) || 1;
    if (!button || button.disabled || !variant || !variant.value) return;
    const wasDisabled = button.disabled;
    const originalLabel = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) {
      status.textContent = status.dataset.adding || '';
      if (status.dataset.adding) button.textContent = status.dataset.adding;
    }
    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(variant.value), quantity }] }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || payload.message || `Cart request failed (${response.status})`);
      if (status) {
        status.textContent = status.dataset.added || '';
        if (status.dataset.added) button.textContent = status.dataset.added;
      }
      root.dispatchEvent(new CustomEvent('v3:cart-added', { bubbles: true, detail: payload }));
    } catch (error) {
      if (status) status.textContent = status.dataset.error || error.message;
      button.textContent = originalLabel;
    } finally {
      button.disabled = wasDisabled;
      button.removeAttribute('aria-busy');
      window.setTimeout(() => {
        button.textContent = originalLabel;
      }, 1200);
    }
  };
  productForms.forEach((form) => {
    const button = form.querySelector('[data-add-button]');
    if (button) button.addEventListener('click', () => addFromForm(form));
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      addFromForm(form);
    });
  });

  const firstPurchase = root.querySelector('[data-v3-section="1"] [data-v3-purchase]');
  const secondPurchase = root.querySelector('[data-v3-section="5"] [data-v3-purchase]');
  const purchaseTarget = secondPurchase || firstPurchase;
  const finalSection = root.querySelector('[data-v3-section="7"]');
  const finalAction = root.querySelector('[data-v3-final-cta]');
  const sticky = root.querySelector('.p10357645771073-sticky-cta[data-v3-sticky-cta]');
  const intersectsViewport = (box) => Boolean(box && box.top < window.innerHeight && box.bottom > 0);
  const updateStickyFromLayout = () => {
    if (!sticky) return;
    const firstBox = firstPurchase && firstPurchase.getBoundingClientRect();
    const secondBox = secondPurchase && secondPurchase.getBoundingClientRect();
    const finalBox = finalSection && finalSection.getBoundingClientRect();
    const visible = Boolean(firstBox && firstBox.bottom <= 0)
      && !intersectsViewport(secondBox)
      && !intersectsViewport(finalBox);
    sticky.classList.toggle('is-visible', visible);
    sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
  };
  if (sticky) {
    let stickyFrame = 0;
    const scheduleStickyUpdate = () => {
      if (stickyFrame) return;
      stickyFrame = window.requestAnimationFrame(() => {
        stickyFrame = 0;
        updateStickyFromLayout();
      });
    };
    window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyUpdate);
    window.addEventListener('pageshow', scheduleStickyUpdate);
    window.addEventListener('load', scheduleStickyUpdate, { once: true });
    updateStickyFromLayout();
  }

  const focusPurchase = () => {
    if (!purchaseTarget) return;
    purchaseTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const control = purchaseTarget.querySelector('[data-variant-choice][aria-checked="true"], [data-v3-variant-select]:not([aria-hidden="true"]), [data-v3-primary-cta]');
    if (control) window.setTimeout(() => control.focus({ preventScroll: true }), 350);
  };
  const stickyAction = sticky && sticky.querySelector('[data-v3-sticky-action]');
  if (stickyAction) stickyAction.addEventListener('click', focusPurchase);
  if (finalAction) finalAction.addEventListener('click', focusPurchase);

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionVideos = Array.from(root.querySelectorAll('video[data-v3-motion]'));
  const applyMotionPreference = () => {
    motionVideos.forEach((video) => {
      if (motionQuery.matches) {
        video.pause();
        return;
      }
      if (video.hasAttribute('data-v3-autoplay') && video.getBoundingClientRect().top < window.innerHeight) {
        const playResult = video.play();
        if (playResult && typeof playResult.catch === 'function') playResult.catch(() => {});
      }
    });
  };
  applyMotionPreference();
  if (typeof motionQuery.addEventListener === 'function') {
    motionQuery.addEventListener('change', applyMotionPreference);
  } else if (typeof motionQuery.addListener === 'function') {
    motionQuery.addListener(applyMotionPreference);
  }

  if ('IntersectionObserver' in window && motionVideos.length) {
    const mediaObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!entry.isIntersecting || motionQuery.matches) {
          video.pause();
        } else if (video.hasAttribute('data-v3-autoplay')) {
          const playResult = video.play();
          if (playResult && typeof playResult.catch === 'function') playResult.catch(() => {});
        }
      });
    }, { rootMargin: '160px 0px', threshold: .05 });
    motionVideos.forEach((video) => mediaObserver.observe(video));
  }
})();
